<template>
    <div class="competences">
        <div
            v-for="m in items"
            :key="m.start"
            class="column"
        >
            <div class="container" v-show="m.hard.length > 0 || m.soft.length > 0">
                <div class="items">
                    <template v-for="type in types">
                        <div
                            class="competence"
                            :class="[type.key]"
                            :key="type.key"
                            v-if="m[type.key].length > 0"
                        >+{{ m[type.key].length }}</div>
                    </template>
                </div>
                <div class="details-wrapper">
                    <div class="details">
                        <h2 class="heading">Подтверждено</h2>
                        <ul class="list">
                            <li
                                class="list-item"
                                :class="[item.competenceType]"
                                v-for="item in m.soft"
                                :key="item.id"
                            >
                                {{ item.name }}
                            </li>
                            <li
                                class="list-item"
                                :class="[item.competenceType]"
                                v-for="item in m.hard"
                                :key="item.id"
                            >
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

const getters = [
    'getCompetences',
];

export default {
    name: 'TimelineCompetencesDesktop',
    props: {
        startOfInterval: {
            type: Object,
            required: true,
        },
        monthsToShow: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        types: [
            {
                key: 'soft',
                name: 'Компетенции',
            },
            {
                key: 'hard',
                name: 'Профессиональные навыки',
            },
        ],
        levels: {
            'basic': 1,
            'intermediate': 2,
            'advanced': 3,
        },
    }),
    computed: {
        ...mapGetters('accountTrack', getters),
        items() {
            return new Array(this.monthsToShow)
                .fill({}, 0 , this.monthsToShow)
                .map((v, i) => {
                    let start = this.startOfInterval.clone();
                    let end = this.startOfInterval.clone();
                    start.add(i, 'months');
                    end.add(i + 1, 'months');
                    return {
                        start: start.unix(),
                        soft: this.getCompetences.filter(c => {
                            return c.moment && c.moment.updatedAt.isBetween(start, end)
                                && c.competenceType === 'soft'
                                && this.isLevelReached(c.requiredLevel, c.competenceLevel);
                        }),
                        hard: this.getCompetences.filter(c => {
                            return c.moment && c.moment.updatedAt.isBetween(start, end)
                                && c.competenceType === 'hard'
                                && c.userAcknowledgment === true;
                        }),
                    };
                });
        },
    },
    methods: {
        isLevelReached(required, current) {
            return current !== null && this.levels[required] <= this.levels[current];
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .competences {
        display: flex;
        margin: 0 32px;

        .column {
            position: relative;
            border: 0;
            flex: 1;
            justify-content: flex-start;

            .container {
                position: absolute;
                margin-left: 3px;
                padding: 0 4px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                background: #E5EFF7;
                border-radius: 0 0 4px 4px;
                cursor: pointer;
                z-index: 20;
                height: 24px;
            }

            .items {
                display: flex;

                .competence {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 600;
                    margin: 4px;

                    &:before {
                        content: " ";
                        display: block;
                        min-width: 16px;
                        height: 16px;
                        background-repeat: no-repeat;
                        background-size: contain;
                        margin-right: 4px;
                    }

                    &.soft {
                        color: #8D7BFB;
                        &:before {
                            background-image: url("../../../../assets/images/account-track/icon/competence-soft.svg");
                        }
                    }
                    &.hard {
                        color: #1AB2D3;
                        &:before {
                            background-image: url("../../../../assets/images/account-track/icon/competence-hard.svg");
                        }
                    }
                }
            }

            .details-wrapper .details{
                display: none;
            }

            .items:hover + .details-wrapper {
                .details {
                    display: block;
                }
            }

            .details:hover {
                display: block;
            }

            &:last-child {
                .details-wrapper .details{
                    left: auto;
                    right: 0;
                }
            }

        }

    }

    .details-wrapper {
        position: relative;
        width: 100%;
        .details {
            position: absolute;
            top: 8px;
            left: 0;
        }
    }

    .details {
        cursor: default;
        background: #FFFFFF;
        box-shadow: 0 2px 24px rgba(155, 161, 166, 0.4);
        border-radius: 4px;
        padding: 24px;
        width: 360px;

        .heading {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #2A2626;
            margin-top: 0;
            margin-bottom: 16px;
        }

        .list {
            margin-top: 12px;

            &-item {
                font-style: normal;
                font-weight: normal;
                font-size: 15px;
                line-height: 22px;
                color: #2A2626;
                padding-left: 24px;

                &.soft {
                    background:  url("../../../../assets/images/account-track/icon/competence-soft.svg") no-repeat left 3px;
                }
                &.hard {
                    background:  url("../../../../assets/images/account-track/icon/competence-hard.svg") no-repeat left 3px;
                }
            }
        }

        li {
            margin-bottom: 12px;

            &:last-of-type {
                margin: 0;
            }
        }

        ul  {
            list-style: none;
            padding-left: 0;
            margin: 0;
        }
    }
</style>
